import { render, staticRenderFns } from "./NumberUnit.vue?vue&type=template&id=fdd4c7de&"
import script from "./NumberUnit.vue?vue&type=script&lang=js&"
export * from "./NumberUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports